module.exports = __webpack_public_path__ + "static/img/WINDSOR-MDF.c900930.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/WINDSOR-MDF.png
// module id = JKuo
// module chunks = 0